const Chiropractors = [
  {
    hideHeading: true,
  },
  {
    tag: 'h2',
    heading: 'What can a pest control specialist help with?',
    description: `The ways in which a pest control professional can help you very much depend on the type of animal you are confronted with, including:`,
    faqs: [
      {
        tag: 'h3',
        q: `Rats and mice`,
        a: `Rat or mice infestations can be troubling, particularly considering their substantial size. Signs to look out for include:
<br><br>
    <h4>Droppings</h4><br>
    Rat droppings tend to be dark brown and shaped like a grain of rice.
    <br>
    <h4>Scratching noises</h4><br>
    Rats and mice are very agile and can make their way into walls and attics.
    <br><br>
    <h4>Holes</h4><br>
    Rats are particularly good at burrowing into the walls, floors, and other parts of the home.
    <br><br>
    <h4>Nests</h4><br>
    Rats often make nests made from materials they find around the house including cardboard and loft insulation.
    <br><br>
    <h4>Footprints</h4><br>
    Rat and mouse footprints can sometimes be found in dusty areas of the home.
    <br><br>
    <h4>Rub marks</h4><br>
    Rodents tend to be a little greasy and can leave marks on household surfaces.
    <br><br>
    The most common places for rodent infestations to occur include decking, garages, drains, compost bins, sheds, and interior walls. Left untreated, rat infestations can lead to serious structural damage in the home. They can also spread a range of very serious diseases including rat-bite fever and leptospirosis. To avoid these threats, it is imperative that you call a pest control professional as soon as you spot the signs of a rodent infestation. Common treatments include eliminating entry points, setting out rodent traps, mouse bait, glue boards, or rodenticides, and thoroughly sanitising the house once the rodents have been removed.
    `,
      },
      {
        tag: 'h3',
        q: `Spiders`,
        a: `Spiders are often considered one of the creepiest pests and can be terrifying for arachnophobes. Australian spiders can be particularly scary due to their fierce reputation. It is always recommended to contact an expert if you are unsure of the species.
<br><br>
        Generally speaking, spiders are most likely to be found in dark crevices of the home and garden. They are also attracted to moist environments so remember to check your basements, sheds and other damp areas, particularly during Autumn when spiders are at their most active.
        <br><br>
        Most of the time, homeowners find spider infestations by simply stumbling upon large groups of spiders. However, other signs of infestation include the appearance of a significant number of spider webs or eggs. Spider eggs are usually laid into a special sac. Each sac contains around 100 eggs and will usually be fixed to household surfaces or hidden inside a web.
        <br><br>
        If you are unfortunate enough to find a spider infestation, it is important that you take the right steps to get rid of it. As well as being unsettling, some spiders can carry a nasty bite or even be venomous, presenting potential dangers to the health of you and your family. Insecticides tend to be the primary mode of removal by pest controllers. Once your home is free from spiders, the pest professional will seal up any vulnerable spots of your home and offer advice about preventing infestations in future.
        `,
      },
      {
        tag: 'h3',
        q: `Termites`,
        a: `Also known as white ants, termites are one of the most destructive pests despite their relatively small size. Termite infestations are relatively easy to recognise as they can wreak havoc on your interiors. Common signs of termite damage include:
        <br><ul>
       <li>Sagging floors.</li>
       <li>Hollow-sounding timber frames.</li>
       <li>Power failures caused by damage to electrical fittings behind walls.</li>
       <li>Damage to skirting boards.</li>
       <li>Cracked plaster or paint.</li>
       <li>Damage to furniture.</li>
       </ul>
<br>
        Termites can invade all areas of the home and cause significant structural damage. Left for too long, they can end up costing huge amounts of money in repairs. As soon as you have spotted an infestation, a professional pest controller will attend your property as quickly as possible to conduct a termite inspection and prevent further damage with termite protection technologies. Common types of termite treatment (or white ant treatment) include using insecticides to get rid of the initial infestation, installing a termite barrier such as a shield, steel mesh, or reticulation system to prevent further infestation, or using chemical barriers such as fipronil or imidacloprid.
         `,
      },
      {
        tag: 'h3',
        q: `Fleas`,
        a: `Fleas are becoming increasingly prevalent across Australia as more people adopt pets such as cats and dogs.
<br><br>
        As well as biting your pets, fleas may hop on to humans and soft furnishings, potentially causing irritating, itchy lesions. If you notice that your pets are scratching a lot, they may well have fleas. These pests are visible with the human eye, so investigate by parting your pet’s fur and looking out for small black specks that move. Most fleas appear around the ears and rump.
        <br><br>
        If you find a flea infestation, a pest controller will be able to help get rid of any fleas that have made their way into your home through steam cleaning or chemical treatment. They may also be able to recommend safe treatments to get rid of the fleas on your pet.
         `,
      },
      {
        tag: 'h3',
        q: `Bees and wasps`,
        a: `If you have a large number of bees or wasp around your home, there may be a nest on your property or in a nearby garden. This can be particularly worrying for people with allergies to wasp stings. Nests tend to be built in sheltered areas such as roof spaces, bird boxes, and wall cavities. They can get very large and look grey and papery in appearance.

        A pest control expert will be able to advise you about the next steps if you find a bee or wasp nest. Most of the time, they will be reluctant to treat bee nests as they are an endangered species. A professional beekeeper may be brought in to advise. Pest controllers can however safely remove wasp nests.
        `,
      },
      {
        tag: 'h3',
        q: `Cockroaches`,
        a: `Cockroaches are nocturnal, so you are more likely to spot signs of their presence rather than the insects themselves. Common signs of a cockroach infestation include:
        <br> <ul><li>Droppings that look a little like ground coffee.</li>
        <li>Skin that has been shed: Cockroaches shed their skin several times as they mature into adults.</li>
        <li>Eggs: Cockroaches lay eggs in a capsule known as an ootheca.</li>
        <li>An unusual and unpleasant odour.</li>
        </ul>
        <br>
        Left untreated, cockroaches will cause damage by munching through food and organic items such as books and leather. Cockroaches tend to live in kitchen cupboards, under sinks, in basements, and at the back of bathroom cabinets. A pest controller will be able to handle a cockroach infestation quickly and easily with an array of chemicals and by creating physical barriers in the home.
        `,
      },
      {
        tag: 'h3',
        q: `Ants`,
        a: `Most homeowners will immediately know if they have an ant infestation, as they will often see large numbers of them. They tend to congregate in places where food is prepared and sometimes settle in kitchens to create nests. Pest control experts can control ant infestations using an array of different treatments including sprays, baits, and dusts. The treatment they use will depend on the species that needs to be dealt with.`,
      },
      {
        tag: 'h3',
        q: `Silverfish`,
        a: `Silverfish love humid areas, which is why they can often be found in bathtubs. Common signs of an infestation include seeing a live bug, finding small, spherical droppings, damage to paper and cardboard, and skin that has been shed. As well as setting off allergies in some people, silverfish can cause considerable damage to the home. They have a particular appetite for paper (especially wallpaper), clothes, and carbohydrates. A pest control professional will usually handle a silverfish infestation with insecticides`,
      },
      {
        tag: 'h3',
        q: `Bed bugs`,
        a: `Bed bugs are nocturnal creatures that can be very difficult to detect. They can also cause great distress to people as they commonly hide in beds and come out at night to bite their occupants. Bed bug bites can be very itchy and seriously impact a person’s quality of life. Other than bites, common signs of an infestation include a sweet, sickly scent on mattresses, carpets and bed frames, blood spots on the mattress or bed linen, and black stains on the mattress. If you discover a bed bug infestation it is imperative that you call in a pest control professional rather than handle the problem yourself as it can be very difficult to completely rid a property of the bugs using DIY methods. A professional will be able to destroy the bed bugs using heat treatment.`,
      },
    ],
  },
  {
    tag: 'h2',
    heading: 'Why should I hire a professional for pest control?',
    description: `Hiring professional pest control services rather than doing the job is a very smart idea as an expert will be able to:`,
    faqs: [
      {
        tag: 'h3',
        q: `Identify the cause and source of infestations accurately`,
        a: `It can be very difficult to discern between different species of pest, particularly if you have not seen the animals in the flesh. A professional will be able to quickly figure out what kind of pests have invaded your home and recommend a range of suitable treatments.`,
      },
      {
        tag: 'h3',
        q: `Provide safe and effective pest control solutions`,
        a: `Pest control experts have a range of different treatments to hand to suit your requirements. As well as recommending treatments based on the species of pest in your home, they will be able to adapt the treatment according to whether you or your family have allergies to certain chemicals or whether you would prefer to capture and release the pests rather than destroy them (although this is not always possible).`,
      },
      {
        tag: 'h3',
        q: `Create treatment programmes`,
        a: `After diagnosing your pest problem and getting rid of the initial infestation and carrying out the necessary cleaning work, a pest controller will be able to work with you to minimise the risk of another unwanted invasion. This could include sealing up entry points and offering advice for making your home as uninviting to pests as possible.`,
      },
      {
        tag: 'h3',
        q: `Cost efficient`,
        a: `Hiring a professional can end up being much cheaper than doing the job yourself. Firstly, a professional job is much more likely to deal with the problem for good. With a DIY job, you may find yourself having to purchase the same expensive chemicals over and over again. The risk of a return also means that repeated damage to your home may become increasingly costly as you are forced to pay for repairs. A professional can help to eliminate this risk and save you money. Finally, a pest expert may even discover you have multiple types of infestation at once and will be able to deal with them before they take hold.`,
      },
    ],
  },
  {
    tag: 'h2',
    heading: `How long do pest control treatments last?`,
    description: `The application of the treatment itself will usually take an hour or so, although the pest professional may need to spend much longer in your home to carry out cleaning work and patch up entry points to your home. Often, they will not need to return to the home if the infestation has been dealt with. However, you may need to book in regular visits if you live in an area particularly prone to infestation.`,
  },
  {
    tag: 'h2',
    heading: 'FAQ about pest control in Australia',
    faqs: [
      {
        tag: 'h3',
        q: `How long do pest control treatments last?`,
        a: `The application of the treatment itself will usually take an hour or so, although the pest professional may need to spend much longer in your home to carry out cleaning work and patch up entry points to your home. Often, they will not need to return to the home if the infestation has been dealt with. However, you may need to book in regular visits if you live in an area particularly prone to infestation.`,
      },
      {
        tag: 'h3',
        q: `What can I expect during a pest control service?`,
        a: `Professional pest controllers are highly trained to prevent and control pests to ensure that their clients’ properties are well cared for. Every inspection involves several steps including:
        <br> <li>Determining whether pests are inside the home: Sometimes homeowners are not quite sure whether pests are actually present within the building as they can be very good at hiding. A professional pest controller will be able to assess the situation by looking for signs such as sounds, tracks, or faeces.</li>
       <li>Identifying the species of pest.</li>
       <li>Dealing with the pests either through extermination or deterrent methods.</li>
       <li>Advising homeowners about any remedial works that need to be done as a result of damage to the property.</li>
       <li>Offering regularly check-ups or prevention services if desired.</li>
       <li>Sealing off entry points to help prevent a return of the pests.</li>
       </ul>

        `,
      },
      {
        tag: 'h3',
        q: `How much do pest control services cost in Australia?`,
        a: `The cost of the services will depend on the size of your home, the size of the infestation, and the species of pest. Generally speaking, however, you can expect to pay between $300 and $800 for a visit from a pest professional.`,
      },
      {
        tag: 'h3',
        q: `Are pest control chemicals eco-friendly?`,
        a: `Not always. However, an increasing number of pest professionals are opting for eco-friendly chemicals to do their work. If you are concerned about environmental issues, it is worth asking your pest control expert whether they have any eco-friendly options available.`,
      },
      {
        tag: 'h3',
        q: `Are pest control chemicals pet friendly?`,
        a: `Although not all chemicals used by pest controllers are pet-friendly, they will often work around the needs and requirements of their clients and use non-toxic options if available.`,
      },
      {
        tag: 'h3',
        q: `Are pest control chemicals harmful to people?`,
        a: `Pest control chemicals can be harmful to people if used incorrectly. Many methods require no chemicals at all, such as heat treatment. If a treatment does require chemicals or other harmful ingredients, your pest control expert will give you advice on how to stay safe.`,
      },
      {
        tag: 'h3',
        q: `How often should I use a professional pest control service?`,
        a: `This depends on how prone your home is to pest invasion. Of course, you should immediately call a pest control service if you suspect an infestation. If your home has a history of infestation or you live in an area where your neighbours are frequently experiencing pest problems, it may also be worth asking for a pest inspection every couple of months. This could potentially prevent an infestation from taking hold.`,
      },
      {
        tag: 'h3',
        q: `Will rain or bad weather affect pest control results?`,
        a: `No. Pest control treatments are designed to withstand moisture. In fact, rain showers may help to lure certain species of pest out of their hiding places, potentially speeding up the elimination process.`,
      },
    ],
  },
];

export default Chiropractors;
